module.exports = __webpack_public_path__ + "img/partners.3502d23.jpg";